module.exports = __webpack_public_path__ + "494cd07c/img/link-icon.fa09ed66.svg";